export type Direction = 'LR' | 'RL';

export const all_directions: Direction[] = ['LR', 'RL'];
